import { useSelector } from "react-redux";

/**
 * Company account type, sourced from the /company/details payload that
 * CompanyDetailsRouter stores in redux (state.global.companyDetails.company).
 * Backend enum: 'standard' | 'restaurant'. Defaults to 'standard' so anything
 * unknown/loading gets the full dashboard (fail-open to the normal UI).
 */
export function useAccountType() {
  return (
    useSelector((s) => s.global?.companyDetails?.company?.account_type) || "standard"
  );
}

/** True when this company should see the simplified, video-wall-focused UI. */
export function useIsRestaurant() {
  return useAccountType() === "restaurant";
}
